"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Constant = require("../Constant");

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  margin-top: 30px;\n  padding-top: 20px;\n  border-top: 1px solid ", ";\n  margin-bottom: 25px;\n\n  @media print, screen and (min-width: ", "px) {\n    margin: 50px auto;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var Footer = _styledComponents.default.footer(_templateObject(), function (_ref) {
  var borderColor = _ref.borderColor;
  return borderColor || _Constant.Color.BUBBLE_GREY;
}, _Constant.Width.MD);

Footer.displayName = 'Footer';
var _default = Footer;
exports.default = _default;